import React, { Component } from "react";

import * as actions from "../../actions";
import { connect } from "react-redux";
import { FETCH_COLLECTIONS } from "../../actions/types";
import EkoDataTable from "../../components/elements/EkoDataTable";
import { toastr } from "react-redux-toastr";
import Api from "../../util/Api";
import Style from "style-it";
import { CSS } from "../../css/tab_datatable";
import {Link} from "react-router";
import { Modal, Button } from "react-bootstrap";
import IncomingStatementsModal from "./IncomingStatementsModal";
import Util from "../../util/Util";

class Collections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collections: [],
      showStatementModal: false, // cb 03/05/2023
      showDeviceModal: false,
      paymentRecorderUserDeviceList: [],
      selectedDeviceId: "",
      selectedRowForDevice: null,
      selectedRowForDeviceType: null,
    };
  }

  fetchCollections() {
    this.props.fetchData("/collection/list", FETCH_COLLECTIONS);
  }

  componentWillMount() {
    localStorage.removeItem("new_customer_id_take_collection");
    localStorage.removeItem("new_collection_amount_fc");
    localStorage.removeItem("selected_list_sales_invoice_id");
    localStorage.removeItem("selected_list_purchases_invoice_id");
    localStorage.removeItem("selected_list_receivable_amount_fc");
    localStorage.removeItem("selected_list_payable_amount_fc");
    localStorage.removeItem("new_collection_from_who_type", 1);
    this.fetchCollections();

    var user_json = JSON.parse(localStorage.getItem("user"));
    Api.get('/company/paymentRecorderUserDeviceList/' + (user_json.id ?? 0), (response, err) => {
      if (response) {
        this.setState({ paymentRecorderUserDeviceList: response.filter(item => item.device_type === 0) });
      }
    });
  }

  openUpdate(selectedRow) {
    this.props.router.push("/dashboard/collections/edit/" + selectedRow.id);
  }

  openInsert(menuItem) {
    localStorage.setItem("new_collection_from_who_type", menuItem);
    this.props.router.push("/dashboard/collections/add");
  }

  openReceipt(selectedRow) {
    this.printShow(selectedRow);
  }
  transformCollectionInvoice(selectedRow) {
    this.props.router.push("/dashboard/salesInvoice/add/toCustomer?collection_id=" + selectedRow.id);
  }
  odealPostDevice(selectedRow,type) {
    this.setState({ showDeviceModal: true, selectedRowForDevice: selectedRow,selectedRowForDeviceType:type });
  }

  sendDevice() {
    if (!this.state.selectedDeviceId) {
      toastr.warning("Uyarı", "Lütfen bir cihaz seçiniz.");
      return;
    }
    const self = this;
    const deviceId = this.state.selectedDeviceId;
    const collectionId = this.state.selectedRowForDevice.id;
    var type = "";
    if(this.state.selectedRowForDeviceType=='advance'){
      type = "d2dsendAdvance";
    }else if(this.state.selectedRowForDeviceType=='current_account'){
      type = "d2dsendCurrentAccount";
    }

    Api.get(`/OdealMobile/${type}/${deviceId}/${collectionId}`, (response, err) => {
      self.setState({ showDeviceModal: false });
      if (response) {
        if(response.code || response.status===false){
          toastr.error("Hata", response.userMessage);
        }else{
          toastr.success("Başarılı", "İşlem başarıyla gönderildi.");
        }
      } else {
        toastr.error("Hata", err.message);
      }
    });
  }

  printShow = row => {
    window.open(
      process.env.REACT_APP_API_URL +
        "/collection/print/" +
        row.id +
        "?token=" +
        localStorage.getItem("token"),
      "_blank"
    );
  };

  onDelete(selectedRow) {
    const self = this;
    Api.delete("/collection/" + selectedRow.id, function(response, err) {
      if (response) {
        self.fetchCollections();
        toastr.success("Başarılı", "Başarıyla Silindi");
      } else toastr.error("Hata", err.message);
    });
  }

  get items() {
    return [
      {
        id: 1,
        link: "/dashboard/collections",
        title: "Tahsil Ettiklerim"
      },

      {
        id: 2,
        link: "/dashboard/collections/outstanding",
        title: "Alacaklarım"
      }
    ];
  }
  /* cb 03/05/2023 */
  sideLink() {
    return (
        <Link className="btn btn-default blue" onClick={this.openIncomingStatements.bind(this)}><i className="fa fa-reply"></i> Banka Hesap Hareketleri (Gelen Para)</Link>
    );
  }
  openIncomingStatements() {
    let self = this;
    self.setState({showStatementModal: true});
  }
  /**/
  render() {
    const insertMenu = this.props.viewOptions
      ? this.props.viewOptions.collections.type
      : false;
    return (
        <div>
          <a style={{"bottom": "6px", "position": "relative", "color": "grey"}}
             onClick={Util.backButton.bind(this, "/dashboard")}><i className="fa fa-arrow-left"></i> Geri Dön</a>
          <IncomingStatementsModal
              showModal={this.state.showStatementModal}
              formData={{"token": localStorage.getItem("token")}}
              onCancel={() => {
                this.setState({showStatementModal: false});
              }}
              errors={this.state.errors}
          />
          <Modal show={this.state.showDeviceModal} onHide={() => this.setState({ showDeviceModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Cihaz Seçimi</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="alert alert-danger">
                <strong>Dikkat!</strong> Tahsilatı cihaza göndermek üzeresiniz, bu işlem geri alınamaz.
              </div>
              <div className="form-group">
                <label>Cihaz Seçin</label>
                <select
                    className="form-control"
                    onChange={(e) => this.setState({ selectedDeviceId: e.target.value })}
                    value={this.state.selectedDeviceId}
                >
                  <option value="">Seçiniz</option>
                  {(this.state.paymentRecorderUserDeviceList || []).map((device, index) => (
                      <option key={index} value={device.id}>
                        {device.title}
                      </option>
                  ))}
                </select>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ showDeviceModal: false })}>İptal</Button>
              <Button bsStyle="primary" onClick={this.sendDevice.bind(this)}>Gönder</Button>
            </Modal.Footer>
          </Modal>
          {Style.it(
              CSS,
              <div>
                <EkoDataTable
                    tabMenu={this.items}
                    selectedTab={1}
                    title={"Tahsilatlar"}
                    openInsert={this.openInsert.bind(this)}
                    transformCollectionInvoice={this.transformCollectionInvoice.bind(this)}
                    odealPostDevice={this.odealPostDevice.bind(this)}
                    openUpdate={this.openUpdate.bind(this)}
                    onDelete={this.onDelete.bind(this)}
                    data={this.props.collections}
                    openReceipt={this.openReceipt.bind(this)}
                    insertMenu={insertMenu}
                    name={"collection"}
                    sideLink={this.sideLink()}
                ></EkoDataTable>
              </div>
          )}
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.data.collection,
    viewOptions: state.data.viewOptions
  };
}

export default connect(mapStateToProps, actions)(Collections);
